import { render } from "./RehabilitacionForm.vue?vue&type=template&id=0d71ae05&scoped=true"
import script from "./RehabilitacionForm.vue?vue&type=script&lang=js"
export * from "./RehabilitacionForm.vue?vue&type=script&lang=js"

import "./RehabilitacionForm.vue?vue&type=style&index=0&id=0d71ae05&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d71ae05"]])

export default __exports__